"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3883],{

/***/ 3883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ArticlePageHero; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../wif-ui-lib/dist/app-a75c1d35.mjs
var app_a75c1d35 = __webpack_require__(3406);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Image-d6406817.mjs
var Image_d6406817 = __webpack_require__(5905);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Video-232035c2.mjs
var Video_232035c2 = __webpack_require__(970);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Block-9b78bd10.mjs
var Block_9b78bd10 = __webpack_require__(4877);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/ArticlePageHero.js










const W = "hero-ratio", q = "article__hero-container", y = "desktop", P = "hero-ratio-without-quote", I = "article__hero-container--without-quote", w = "article__header", A = "article__header__no-buttons", D = "article__save-button", F = "article__save-button__svg", G = "button__icon", M = "article__hero-container__wrapper", O = "article__hero-container__wrapper__reference", V = "article__hero-container__wrapper__reference__text", j = "article__hero-container__no-sibling", z = "article__quote", J = "article__quote__light", K = "article__quote__text__dark__title", U = "article__quote__text__light__title", X = "article__quote__text__light__source", Y = "article__quote__text__light__ranking", Z = "article__leadText", $ = "article__description", t = {
  heroRatio: W,
  articleHeroContainer: q,
  desktop: y,
  heroRatioWithoutQuote: P,
  articleHeroContainerWithoutQuote: I,
  articleHeader: w,
  articleHeaderNoButtons: A,
  articleSaveButton: D,
  articleSaveButtonSvg: F,
  buttonIcon: G,
  articleHeroContainerWrapper: M,
  articleHeroContainerWrapperReference: O,
  articleHeroContainerWrapperReferenceText: V,
  articleHeroContainerNoSibling: j,
  articleQuote: z,
  articleQuoteLight: J,
  articleQuoteTextDarkTitle: K,
  articleQuoteTextLightTitle: U,
  articleQuoteTextLightSource: X,
  articleQuoteTextLightRanking: Y,
  articleLeadText: Z,
  articleDescription: $
};
function C(l) {
  const {
    quote: { field: s, title: n, source: _, ranking: g }
  } = l, a = s === "light", c = (0,app_a75c1d35.c)(
    t.articleQuote,
    a && t.articleQuoteLight
  ), p = (0,app_a75c1d35.c)({
    [app_a75c1d35.t.textsLeadTextBold]: a,
    [t.articleQuoteTextLightTitle]: a,
    // Override light mode styling and typography with dark mode
    [app_a75c1d35.t.textsLeadText]: !a,
    [t.articleQuoteTextDarkTitle]: !a
  });
  let m = "", i = "";
  return a && (m = (0,app_a75c1d35.c)(
    app_a75c1d35.t.textsLeadText,
    t.articleQuoteTextLightSource
  ), i = (0,app_a75c1d35.c)(
    app_a75c1d35.t.textsLeadTextBold,
    t.articleQuoteTextLightRanking
  )), /* @__PURE__ */ react.createElement(
    "div",
    {
      className: c,
      "data-testid": "article-page-hero-quote-container"
    },
    a ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("p", { className: i }, "#", g), /* @__PURE__ */ react.createElement("p", { className: p, itemProp: "description" }, n), /* @__PURE__ */ react.createElement("p", { className: m }, _)) : /* @__PURE__ */ react.createElement("p", { className: p, itemProp: "description" }, n)
  );
}
function me({ isSaved: l = !1, onClick: s }) {
  const n = l ? x.HEART_FILLED : x.HEART;
  return /* @__PURE__ */ e.createElement(
    B.IconLabel,
    {
      text: "Save",
      onClick: s,
      icon: {
        type: n,
        size: 16,
        className: t.articleSaveButtonSvg
      }
    }
  );
}
function ue(l) {
  const {
    assetType: s,
    heading: n,
    leadText: _,
    heroSource: g,
    imageReference: a,
    quote: c,
    hasIcons: p,
    description: m
  } = l, { displaySource: i, altText: T, mimeType: E, credits: f } = g, h = (0,react.useRef)(null), L = (0,app_a75c1d35.c)(
    app_a75c1d35.t.headingPage,
    t.articleHeader,
    p ? "" : t.articleHeaderNoButtons
  ), N = (0,app_a75c1d35.c)(t.articleHeroContainer, {
    [t.articleHeroContainerWithoutQuote]: !c,
    [t.articleHeroContainerNoSibling]: !(h.current && h.current.nextElementSibling)
  }), H = (0,app_a75c1d35.c)(
    app_a75c1d35.t.textsCaption,
    t.articleHeroContainerWrapperReferenceText
  ), S = (0,app_a75c1d35.c)(
    app_a75c1d35.t.textsComponentTitleBold,
    t.articleLeadText
  ), Q = (0,app_a75c1d35.c)(
    app_a75c1d35.t.textsLeadText,
    t.articleDescription
  ), u = typeof i != "string";
  return /* @__PURE__ */ react.createElement("div", { className: "article", "data-testid": "article-page" }, /* @__PURE__ */ react.createElement(
    Block_9b78bd10.B,
    {
      topPadding: Block_9b78bd10.B.Padding.SMALL,
      bottomPadding: Block_9b78bd10.B.Padding.LARGE,
      "data-testid": "article-page-block"
    },
    /* @__PURE__ */ react.createElement(
      Block_9b78bd10.B.Content,
      {
        "data-testid": "article-page-block-content",
        itemScope: !0,
        itemType: "https://schema.org/Thing"
      },
      /* @__PURE__ */ react.createElement("h1", { className: L, itemProp: "name" }, n),
      /* @__PURE__ */ react.createElement(
        "div",
        {
          className: N,
          ref: h,
          itemScope: !0,
          itemType: "https://schema.org/ImageObject"
        },
        s === "image" ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("div", { className: t.articleHeroContainerWrapper }, /* @__PURE__ */ react.createElement(
          Image_d6406817.I,
          {
            src: u ? i.imageSrc : "",
            width: u ? i.width : 0,
            height: u ? i.height : 0,
            altText: T,
            imageLoader: u ? i.imageLoader : () => "",
            styling: Image_d6406817.a.ARTICLE_PAGE_HERO,
            "data-testid": "article-page-image",
            credits: f
          }
        ), a && /* @__PURE__ */ react.createElement(
          "div",
          {
            className: t.articleHeroContainerWrapperReference,
            "data-testid": "article-hero-image-reference"
          },
          /* @__PURE__ */ react.createElement(
            "p",
            {
              className: H,
              itemProp: "citation"
            },
            a
          )
        )), c && /* @__PURE__ */ react.createElement(C, { quote: c })) : /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(
          Video_232035c2.V,
          {
            title: T,
            autoplay: !0,
            videoType: "asset",
            video: {
              src: u ? "" : i,
              mimeType: E
            },
            "data-testid": "article-page-video"
          }
        ), c && /* @__PURE__ */ react.createElement(C, { quote: c }))
      ),
      _ && /* @__PURE__ */ react.createElement("p", { className: S, itemProp: "description" }, _),
      m && /* @__PURE__ */ react.createElement(
        "div",
        {
          className: (0,app_a75c1d35.c)(app_a75c1d35.t.richText, Q),
          itemProp: "description"
        },
        m
      )
    )
  ));
}

//# sourceMappingURL=ArticlePageHero.js.map

// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(5218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/constants/app.ts
var app = __webpack_require__(5884);
// EXTERNAL MODULE: ./src/hooks/useImageDataHandler.ts
var useImageDataHandler = __webpack_require__(4847);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
;// CONCATENATED MODULE: ./src/magnolia/components/ArticlePageHero/ArticlePageHero.tsx









var HtmlParser = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4288).then(__webpack_require__.bind(__webpack_require__, 4288));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4288)
            ];
        }
    }
});
var noop = function() {
/* save feature removed */ };
function ArticlePageHero(props) {
    var heading = props.heading, leadText = props.leadText, asset = props.asset, imageReference = props.imageReference, quote = props.quote, icons = props.icons, description = props.description;
    var isPreview = (0,router.useRouter)().isPreview;
    var imageDataHandler = (0,useImageDataHandler/* default */.Z)();
    var generateHeroSource = function() {
        var ref;
        if (asset.field === "image") {
            var image = asset.image;
            var credits = "";
            if (typeof image !== "string") {
                var ref1;
                var ref2;
                credits = (ref2 = image === null || image === void 0 ? void 0 : (ref1 = image.metadata) === null || ref1 === void 0 ? void 0 : ref1.rights) !== null && ref2 !== void 0 ? ref2 : "";
            }
            var imageData = imageDataHandler(image, {
                maxViewport: app/* Viewport.md */.l_.md
            });
            return {
                displaySource: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageData), {
                    imageSrc: imageData.src
                }),
                altText: asset.imageAltText || "",
                mimeType: undefined,
                credits: credits
            };
        }
        return {
            displaySource: (0,magnolia/* getAssetPath */.K3)(asset.video, isPreview),
            imageLoadHandler: undefined,
            altText: asset.videoAltText || "",
            mimeType: (ref = asset.video.metadata) === null || ref === void 0 ? void 0 : ref.mimeType
        };
    };
    var descriptionOrUndefined = (description === null || description === void 0 ? void 0 : description.trim()) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlParser, {
        html: description
    }) : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ue, {
        assetType: asset.field,
        heading: heading,
        leadText: leadText === null || leadText === void 0 ? void 0 : leadText.trim(),
        heroSource: generateHeroSource(),
        imageReference: imageReference,
        quote: getQuoteFromQuoteNode(quote),
        hasIcons: icons === "true",
        description: descriptionOrUndefined,
        isSaved: false,
        onSave: noop
    });
}
function getQuoteFromQuoteNode(node) {
    if (node.field === "none") return undefined;
    return {
        field: node.field,
        title: node.title,
        source: node.source,
        ranking: node.ranking
    };
}

;// CONCATENATED MODULE: ./src/magnolia/components/ArticlePageHero/index.ts
/* istanbul ignore file */ 


/***/ }),

/***/ 970:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ h; },
/* harmony export */   "a": function() { return /* binding */ C; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3406);
/* harmony import */ var _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4877);



const A = "video", f = "video__hero", g = "video__article", k = "desktop", P = "video__caption", d = {
  video: A,
  videoHero: f,
  videoArticle: g,
  desktop: k,
  videoCaption: P
};
var C = /* @__PURE__ */ ((t) => (t.ARTICLE = "videoArticle", t.HERO = "videoHero", t))(C || {});
function h({
  title: t,
  caption: s,
  styling: i,
  autoplay: l,
  embed: o,
  image: u = "",
  videoType: c,
  video: r,
  viewport: m
}) {
  const E = Array.isArray(r) ? r.find((y) => m && y.device?.includes(m)) : r, a = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(d.video, i && d[i]), p = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, c === "icareusIframe" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: a,
      dangerouslySetInnerHTML: { __html: o }
    }
  ), c === "embed" && (o?.includes("iframe") ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: a,
      dangerouslySetInnerHTML: { __html: o }
    }
  ) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "video",
    {
      "data-testid": "videoplayer-embed",
      itemProp: "video",
      title: t,
      className: a,
      src: o,
      playsInline: !0,
      controls: !0
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("track", { kind: "captions" })
  )), c === "asset" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, l ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "video",
    {
      "data-testid": "videoplayer-asset",
      itemProp: "video",
      title: t,
      className: a,
      src: E?.src,
      autoPlay: l,
      loop: !0,
      muted: !0,
      playsInline: !0
    }
  ) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "video",
    {
      "data-testid": "videoplayer-asset-control",
      itemProp: "video",
      title: t,
      className: a,
      controls: !0,
      poster: u,
      playsInline: !0
    },
    !Array.isArray(r) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", { src: r.src, type: r.mimeType }),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("track", { kind: "captions" })
  )));
  return i === "videoArticle" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B,
    {
      topPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Padding.SMALL,
      bottomPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Padding.LARGE,
      "data-testid": "article-video"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Content, { "data-testid": "article-video-content" }, p, s && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", { className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsCaption, d.videoCaption) }, s))
  )) : p;
}

//# sourceMappingURL=Video-232035c2.mjs.map


/***/ })

}]);